module.exports = __webpack_public_path__ + "media/images/icon__reddit-2025d3f9ccc9cee4bfabb107341faba5.png";